import type { FC } from 'react';

import ChainSvg from 'images/srp-illustration-chain.svg';
import type { IconProps } from './types';

const Chain: FC<IconProps> = ({ className }) => {
  return <img className={className} src={ChainSvg} />;
};

export default Chain;
